<div class="trigger-container">
  <i2g-icon [icon]="contextMenuIcon"></i2g-icon>
  <div
    class="trigger"
    i2gPopper
    [target]="contextMenu"
    [triggerOnClick]="true"
    [placement]="placement"
  ></div>
</div>

<!-- The actual content to be displayed -->
<div class="context-menu" #contextMenu>
  <ng-content></ng-content>
</div>
